var app = angular.module('leonardo');

var ConfigThemeService = function ($rootScope, $window, Config, RestangularProvider) {
  var service = {
    default_config: {
      name: 'Leonardo',
      logo1: '/img/logo_new_one.svg',
      logo2: '/img/logo_public_new_one.svg',
      logo3: '/img/favicon-96x96.png',
      url_config: {
        web_url: window.location.origin,
        api_url: Config.baseURL,
        media_url: Config.baseURLMedia
      },
      theme_config: {
        primaryColor: '#36475F',
        secondaryColor: '#2895F1',
        tertiaryColor: '#A9B1BC',
        successColor: '#7ED321',
        warningColor: '#F5A623',
        errorColor: '#CE3B4D',
        auxColor: '#861B89'
      }
    },
    config: {
      name: 'Leonardo',
      logo1: '/img/logo_new_one.svg',
      logo2: '/img/logo_public_new_one.svg',
      logo3: '/img/favicon-96x96.png',
      url_config: {
        web_url: window.location.origin,
        api_url: Config.baseURL,
        media_url: Config.baseURLMedia
      },
      theme_config: {
        primaryColor: '#36475F',
        secondaryColor: '#2895F1',
        tertiaryColor: '#A9B1BC',
        successColor: '#7ED321',
        warningColor: '#F5A623',
        errorColor: '#CE3B4D',
        auxColor: '#861B89'
      }
    },
    debug: false,
    updated: false,
    updating: false
  };

  service.restoreTheme = function () {
    RestangularProvider.all('get-theme')
      .customGET('', { noerror: true })
      .then(
        function (theme_config) {
          if (!isEmpty(theme_config)) {
            theme_config = service.compile_theme_config(theme_config);
            service.updateConfig(theme_config);
            RestangularProvider.setBaseUrl(service.config.url_config.api_url + '/api/2.0');
            $rootScope.$broadcast('white-label:update-theme');
          } else {
            service.updateConfig(ConfigThemeService.default_config);
            RestangularProvider.setBaseUrl(service.config.url_config.api_url + '/api/2.0');
            $rootScope.$broadcast('white-label:update-theme');
          }
        },
        function () {
          service.updateConfig(ConfigThemeService.default_config);
          RestangularProvider.setBaseUrl(service.config.url_config.api_url + '/api/2.0');
          $rootScope.$broadcast('white-label:update-theme');
        }
      );
    RestangularProvider.setDefaultHeaders({});
  };

  service.compile_theme_config = function (theme_config) {
    return {
      name: theme_config.name,
      logo1: theme_config.principal_logo,
      logo2: theme_config.public_logo,
      logo3: theme_config.favicon_logo,
      url_config: {
        "api_url": theme_config.api_url,
        "web_url": theme_config.web_url,
        "media_url": theme_config.media_url
      },
      theme_config: {
        "auxColor": theme_config.aux_color,
        "errorColor": theme_config.error_color,
        "primaryColor": theme_config.primary_color,
        "successColor": theme_config.success_color,
        "warningColor": theme_config.warning_color,
        "tertiaryColor": theme_config.tertiary_color,
        "secondaryColor": theme_config.secondary_color
      }
    }
  };

  service.resetConfig = function () {
    service.updateConfig(service.default_config);
    window.oldReduxStore.dispatch(window.oldReduxActions.resetConfiguration());
  };

  service.updateThemeConfig = function (config, updated) {
    service.updateConfig(config, updated);
    RestangularProvider.setBaseUrl(config.url_config.api_url + '/api/2.0');
    $window.location.origin = config.url_config.web_url;
    $rootScope.$broadcast('white-label:update-theme');
  };

  service.updateConfig = function (config, updated) {
    if (!isEmpty(config)) {
      service.config = {
        name: config.name,
        logo1: config.logo1 || service.default_config.logo1,
        logo2: config.logo2 || service.default_config.logo2,
        logo3: config.logo3 || service.default_config.logo3,
        url_config: !isEmpty(config.url_config) ? config.url_config : service.default_config.url_config,
        theme_config: !isEmpty(config.theme_config) ? config.theme_config : service.default_config.theme_config
      };
      service.updated = !isNull(updated) ? updated : true;
      $rootScope.$broadcast('white-label:update-theme');
      $rootScope.$broadcast('config-theme:updated');
    }
  };

  service.updateName = function (name) {
    service.config.name = name || service.default_config.name;
    $rootScope.$broadcast('white-label:update-theme');
  };

  service.updateTheme = function (config) {
    service.config.theme_config = config;
    $rootScope.$broadcast('config-theme:updated');
  };

  service.updateLogo = function (logo, url) {
    service.config[logo] = url;
    $rootScope.$broadcast('white-label:update-theme');
  };

  service.generateURL = function (path) {
    if (!service.updated) {
      return Config.baseURL + path;
    } else {
      return service.config.url_config.api_url + path;
    }
  };

  service.generateURLMedia = function (path) {
    if (!service.updated) {
      return Config.baseURLMedia + path;
    } else {
      return service.config.url_config.media_url + path;
    }
  };

  service.generateURI = function (path) {
    if (!service.updated) {
      return new URI(Config.baseURLMedia + path);
    } else {
      return new URI(service.config.url_config.api_url + path);
    }
  };

  service.getColor = function (color, opacity) {
    if (!isNull(opacity)) {
      var rgb = hexToRgb(service.config.theme_config[color]);
      return rgb ? 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', ' + opacity + ')' : '';
    }
    return service.config.theme_config[color];
  };

  service.getDefaultColor = function (color, opacity) {
    if (!isNull(opacity)) {
      var rgb = hexToRgb(service.default_config.theme_config[color]);
      return rgb ? 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', ' + opacity + ')' : '';
    }
    return service.default_config.theme_config[color];
  };

  service.getLogo = function (logo) {
    if (service.updating || service.updated) {
      return service.config[logo];
    } else {
      return window.location.origin + service.config[logo];
    }
  };

  service.reduxSubscribe = function () {
    window.oldReduxStore.subscribe(() => {
      service.updateConfig(window.oldReduxStore.getState().whiteLabel);
    });
  };

  if (window.oldReduxStore) {
    service.reduxSubscribe();
  } else {
    setTimeout(function () {
      service.reduxSubscribe();
    }, 60 * 1000);
  }

  return service;
};

app.factory('ConfigThemeService', ['$rootScope', '$window', 'Config', 'Restangular', ConfigThemeService]);
